import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tour-card',
  templateUrl: './tour-card.component.html',
  styleUrls: ['./tour-card.component.scss']
})
export class TourCardComponent {
  @Input() currentStep = 0;
  @Input() totalSteps = 0;
  @Input() text = '';
  @Input() actionMsg = '';
  @Input() tipRight = false;
  @Output() next = new EventEmitter<any>();
  @Output() quit = new EventEmitter<any>();
}
